// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3hqBN","label":"Completed_label__2iaMH"};